import {
  Box,
  Button,
  Drawer,
  DrawerOverlay,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  DrawerContent,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PROTECTED_PATHS } from "routes/pagePath";

interface Props {
  onClose: () => void;
  isOpen: boolean;
  variant: any;
}

const SidebarContent = ({ onClick }: { onClick: () => void }) => {
  const history = useNavigate();

  const [buttonIndex, setButtonIndex] = useState(0);

  const buttonItem = [
    {
      name: "Home",
      path: PROTECTED_PATHS.DASHBOARD,
    },
    {
      name: "Scripts",
      path: PROTECTED_PATHS.UPLOAD_ADMIN,
    },
    {
      name: "Composers",
      path: PROTECTED_PATHS.COMPOSER,
    },
  ];

  const activeClass = "#387AD8";
  const inActiveClass = "#B7C3D5";
  const hoverClass = "#78B9FF";

  return (
    <VStack>
      {buttonItem.map((item, index) => (
        <Button
          key={index}
          onClick={() => {
            setButtonIndex(index);
            history(item.path);
          }}
          w="100%"
          bg={buttonIndex === index ? activeClass : inActiveClass}
          _hover={{ bg: hoverClass }}
        >
          {item.name}
        </Button>
      ))}
    </VStack>
  );
};

const Sidebar = ({ isOpen, variant, onClose }: Props) => {
  return variant === "sidebar" ? (
    <Box position="fixed" left={0} p={5} w="200px" top={0} h="100%" bg="#dfdfdf" boxShadow="lg">
      <Box mt="64px">
        <SidebarContent onClick={onClose} />
      </Box>
    </Box>
  ) : (
    <Drawer isOpen={isOpen} placement="left" onClose={onClose}>
      <DrawerOverlay>
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>Chakra-UI</DrawerHeader>
          <DrawerBody>
            <SidebarContent onClick={onClose} />
          </DrawerBody>
        </DrawerContent>
      </DrawerOverlay>
    </Drawer>
  );
};

export default Sidebar;
